// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-2v8_M05","api-description-input":"api-description-input-1doaSQX","submit-button":"submit-button-2YYe67N","no-data-row":"no-data-row-2C2Ls7O"};